import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "min-w-0 overflow-hidden gap-x1 flex sm:ml-auto sm:items-end sm:mr-x2 md:flex-col md:gap-4"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "o-text-caption c-magic-line c-magic-line--underline" }

import { computed } from 'vue';
import breakpointsState from '@/core/responsive/breakpoints/breakpoints-state.observable';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';
import generateCdnUrlWithParams from '@/core/responsive/image/helpers/generate-cdn-url-including-params';
import { LightingSpecification } from '@/types/productServerApi';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSpotEnergyClassification',
  props: {
    lightingSpecification: null
  },
  setup(__props: any) {

const props = __props as {
    lightingSpecification: LightingSpecification | undefined;
}



const tempConstantEnergyLabelBaseUrl = '/layout/images/energy-labels';

const globalLabels = useGlobalLabels(GlobalLabels.product);

const energyLabelUrl = computed(() => {
    const isMobile = breakpointsState.activeBreakpoint === 'xs';
    const imageDirectionParameter = isMobile ? 'right' : 'left';
    const energyClassification = props.lightingSpecification?.energyClassification?.toLowerCase();
    const lightingUrl = `${tempConstantEnergyLabelBaseUrl}/${energyClassification}-${imageDirectionParameter}.png`;
    return generateCdnUrlWithParams(
        lightingUrl,
        { format: 'auto', width: 38 },
        false);
});


return (_ctx: any,_cache: any) => {
  return (!!__props.lightingSpecification?.energyClassification)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("a", {
          href: __props.lightingSpecification.energyClassificationUrl,
          class: "relative z-2",
          tabindex: "-1",
          target: "_blank"
        }, [
          _createElementVNode("img", {
            src: _unref(energyLabelUrl),
            alt: __props.lightingSpecification.energyClassification,
            width: "35",
            height: "100%"
          }, null, 8, _hoisted_3)
        ], 8, _hoisted_2),
        (__props.lightingSpecification.specificationUrl)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "c-link w-full flex mt-1 relative z-2",
              href: __props.lightingSpecification.specificationUrl,
              tabindex: "-1",
              target: "_blank"
            }, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(globalLabels).lightingClassificationDataSheet), 1)
            ], 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})